import { render, staticRenderFns } from "./SbButton.vue?vue&type=template&id=11609760&scoped=true&"
import script from "./SbButton.vue?vue&type=script&lang=js&"
export * from "./SbButton.vue?vue&type=script&lang=js&"
import style0 from "./SbButton.vue?vue&type=style&index=0&id=11609760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11609760",
  null
  
)

export default component.exports